import axios from "axios";

import { apiConfig } from "../config/authConfig";

import { IShipmentDocument, IShipmentPacketSearchRequest } from "../types/shipmentPacket";

import { CredentialManager } from "../classes/credentialManager";

export namespace ShipmentPacketService {
	const credentialManager = CredentialManager.getInstance();

	/**********
	  * Searches shipments by provided criteria.
	  * @param request The search request criteria.
	  * @return A promise with the API response as an array of IDocument.
	  **********/
	export async function searchShipmentDocuments(request: IShipmentPacketSearchRequest) {
		const apiResponse = axios.post(
			apiConfig.default + "/document/shipmentpacket/search",
			request,
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}

	/**********
	 * Convert one api response object to one ShipmentDocument.
	 * @param data ShipmentDocument response data from an API.
	 **********/
	export function mapShipmentDocument(data: any) {
		let packet: IShipmentDocument = {
			documentId: data.documentId,
			documentTypeId: data.documentTypeId,
			documentTypeName: data.documentTypeName,
			shipmentId: data.shipmentId,
			bol: data.bol,
			customerId: data.customerId,
			customerName: data.customerName,
			vendorId: data.vendorId,
			vendorName: data.vendorName,
			shipmentDate: data.shipmentDate ? new Date(data.shipmentDate) : undefined,
		}

		return packet;
	}

	/**********
	 * Convert an array of api response objects to an array of ShipmentPackets.
	 * @param data ShipmentDocument data from an API response.
	 **********/
	export function mapShipmentDocuments(data: any) {
		let packets: IShipmentDocument[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any) => {
				packets.push(mapShipmentDocument(item));
			})
		}

		return packets;
	}
}